// extracted by mini-css-extract-plugin
export default {"root":"BundleSelect-root","option":"BundleSelect-option"};